import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import Control from './index';
import MobileControl from './MobileControl';

const ResponsiveControl = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileControl />}
      desktop={<Control />}
    />
  );
};

export default ResponsiveControl;